import {
  BtmcOrganization
} from "../../../model";
import {PlatformSubSection} from "@tracabois/template";
import {BrandNumberForm} from "./BrandNumberForm";
import {FormComposableState} from "@komune-io/g2-composable";
import { brandConfig } from "@tracabois/domain";
import { DropPictureProps } from "@komune-io/g2-components";

export interface BrandNumberSectionProps {
  form: FormComposableState
  item?: BtmcOrganization,
  dropPictureProps: DropPictureProps
}

export const BrandNumberSection = (props: BrandNumberSectionProps) => {
  const {item, form, dropPictureProps} = props

  return (
    <PlatformSubSection title={brandConfig().acronym}>
      {!!item &&
      <BrandNumberForm
          form={form}
          dropZonePicture={dropPictureProps}
          item={item}
      />
      }
    </PlatformSubSection>
  )
}
